import { Paragraph, TextRun, Table, TableRow, TableCell } from "docx";
import { formatFloats } from "./published-model-helpers";
import { formatNeedRange } from "./export-util";

export const createMatrixTable = (matrices, xdimensions, ydimensions) => {
  if (!matrices || !matrices.length || !xdimensions || !ydimensions) {
    return null;
  }

  const matrix = matrices[0]; // Use first matrix for now

  // Create main header row with need ranges
  const needMatrixHeaderRow = new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph("")], // Empty cell for academic rank column
      }),
      ...xdimensions.map(
        (dimension, index) =>
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: formatNeedRange(dimension, index, xdimensions),
                    bold: true,
                  }),
                ],
              }),
            ],
            columnSpan: 3, // Spans across Merit award, Need metric, Cap dollar
          })
      ),
    ],
  });

  // Create sub-header row with Merit award, Need metric, Cap dollar
  const needMatrixSubHeaderRow = new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph("Academic Rank")], // Empty cell for academic rank
      }),
      ...xdimensions.flatMap(() => [
        new TableCell({
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: "Merit $",
                }),
              ],
            }),
          ],
        }),
        new TableCell({
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: "Need %",
                }),
              ],
            }),
          ],
        }),
        new TableCell({
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: "Cap $",
                }),
              ],
            }),
          ],
        }),
      ]),
    ],
  });

  // Create data rows for each academic rank
  const needMatrixDataRows = ydimensions.map((ydimension, yIndex) => {
    const academicRank = ydimension[0]; // Use first value as rank

    return new TableRow({
      children: [
        new TableCell({
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: academicRank.toString(),
                  bold: true,
                }),
              ],
            }),
          ],
        }),
        ...xdimensions.flatMap((xdimension, xIndex) => {
          // Get values from matrix arrays
          const meritValue = matrix.meritAward[yIndex]?.[xIndex];
          const needValue = matrix.needMetric[yIndex]?.[xIndex];
          const capValue = matrix.capDollar[yIndex]?.[xIndex];

          return [
            new TableCell({
              children: [
                new Paragraph(
                  meritValue !== null && meritValue !== undefined
                    ? formatFloats(meritValue, "currency")
                    : ""
                ),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph(
                  needValue !== null && needValue !== undefined
                    ? formatFloats(needValue, "number")
                    : ""
                ),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph(
                  capValue !== null && capValue !== undefined
                    ? formatFloats(capValue, "currency")
                    : ""
                ),
              ],
            }),
          ];
        }),
      ],
    });
  });

  return new Table({
    rows: [needMatrixHeaderRow, needMatrixSubHeaderRow, ...needMatrixDataRows],
  });
};
